import { render, staticRenderFns } from "./biaozhunhua.vue?vue&type=template&id=7c7dacac&scoped=true&"
import script from "./biaozhunhua.vue?vue&type=script&lang=js&"
export * from "./biaozhunhua.vue?vue&type=script&lang=js&"
import style0 from "./biaozhunhua.vue?vue&type=style&index=0&id=7c7dacac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7dacac",
  null
  
)

export default component.exports